import React, { useRef, useState } from "react"
import Card from "../blocks/card/Card"
import * as classNames from "./CardSwitch.module.scss"
import Section from "../../../core/layout/main/section/Section"
import Image from "../blocks/image/Image"
function CardSwitch({
  firstTab,
  secondTab,
  mainTitle,
  firstTabTitle,
  secondTabTitle,
}) {
  const [activeTab, setActiveTab] = useState("firstTab")

  const handleShowOverlay = (e, index) => {
    e.preventDefault()
    const cards = document.querySelectorAll(`.${classNames.Card}`)
    cards[index].classList.toggle(classNames.showOverlay)
  }

  const handleHideOverlay = (index) => {
    const card = document.querySelectorAll(`.${classNames.Card}`)
    card[index].classList.remove(classNames.showOverlay)
  }

  return (
    <Section classNames={classNames.sectionStyle + " xxlarge"}>
      <h2 style={{ textAlign: "center" }}>{mainTitle}</h2>
      <div className={classNames.tabButtons}>
        <div className={classNames.tabbtnBg}>
          <button
            className={`${classNames.tabButton} ${
              activeTab === "firstTab" ? classNames.active : ""
            }`}
            onClick={() => setActiveTab("firstTab")}
          >
            {firstTabTitle}
          </button>
          <button
            className={`${classNames.tabButton} ${
              activeTab === "secondTab" ? classNames.active : ""
            }`}
            onClick={() => setActiveTab("secondTab")}
          >
            {secondTabTitle}
          </button>
        </div>
      </div>
      <div className={classNames.cardSwitch}>
        <div className={classNames.cardsContainer}>
          {activeTab === "firstTab" &&
            firstTab.map((card, index) => (
              <Card
                className={`${classNames.Card} ${
                  activeTab === "firstTab" ? "show-overlay" : ""
                }`}
                key={index}
                onMouseLeave={() => handleHideOverlay(index)}
              >
                {card.image.data.map((img) => (
                  <Image
                    dataSizesPreset={'S'}
                    formats={img.attributes.formats}
                    imgSrc={img.attributes.url}
                    imgAlt={img.attributes.alternativeText}
                    imgHeight="250"
                    imgWidth="100%"
                    loading="lazy"
                    className={classNames.img + " centered"}
                  />
                ))}
                <div className={classNames.bottomContent}>
                  <h3>{card.name}</h3>
                  <h4 className={classNames.jobHeader}>{card.job}</h4>
                  <a
                    href="#"
                    className={classNames.lienUnstyled + " lienUnstyled"}
                    onClick={(e) => handleShowOverlay(e, index)}
                  >
                    <img src="https://media.paritel.fr/paritel-www-dev/assets/Trace_361_e95112c008.png" />
                    En savoir plus
                  </a>
                </div>
                <div className={classNames.overlay}>
                  <h3>{card.name}</h3>
                  <h4>{card.job}</h4>
                  <p>{card.description}</p>
                </div>
              </Card>
            ))}
        </div>
        <div className={classNames.cardsContainer}>
          {activeTab === "secondTab" &&
            secondTab.map((card, index) => (
              <Card
                className={classNames.Card}
                key={index}
                onMouseLeave={() => handleHideOverlay(index)}
              >
                {card.image.data.map((img) => (
                  <Image
                    dataSizesPreset={'S'}
                    formats={img.attributes.formats}
                    imgSrc={img.attributes.url}
                    imgAlt={img.attributes.alternativeText}
                    imgHeight="250"
                    imgWidth="100%"
                    loading="lazy"
                    className={classNames.img + " centered"}
                  />
                  // <img className={classNames.img + " centered"} src={img.attributes.url}></img>
                ))}
                <div className={classNames.bottomContent}>
                  <h3>{card.name}</h3>
                  <h4>{card.job}</h4>
                  <a
                    href="#"
                    className={classNames.lienUnstyled + " lienUnstyled"}
                    onClick={(e) => handleShowOverlay(e, index)}
                  >
                    <img src="https://media.paritel.fr/paritel-www-dev/assets/Trace_361_e95112c008.png" />
                    En savoir plus
                  </a>
                </div>
                <div className={classNames.overlay}>
                  <h3>{card.name}</h3>
                  <h4>{card.job}</h4>
                  <p>{card.description}</p>
                </div>
              </Card>
            ))}
        </div>
      </div>
    </Section>
  )
}

export const name = "CardSwitch"

export const init = (componentData, pageContext) => {
  return (
    <CardSwitch
      mainTitle={componentData.mainTitle}
      firstTab={componentData.firstTab}
      secondTab={componentData.secondTab}
      firstTabTitle={componentData.firstTabTitle}
      secondTabTitle={componentData.secondTabTitle}
    />
  )
}

export default CardSwitch
